module.exports = __webpack_public_path__ + "media/images/logo-a6324dc1af1d74f6a4373928c7abe151.png";